import React from 'react';
import { useSelector } from 'react-redux';
import { MAPPING } from '../helpers';
import { errorsSelector } from '../store/inventory-near-you/selector';

const { apiErrorMessage } = MAPPING;
const ErrorMessage = () => {

  const errors = useSelector(errorsSelector);
  if (!errors) {
    return null;
  }
  return (
    <p className="h6 mb-0" dangerouslySetInnerHTML={{__html: apiErrorMessage}} />
  );
};

export default ErrorMessage;